"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Success = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var Success = function Success(fileId, fileName, fileSize, urlDownload, providers, fileBlob) {
  (0, _classCallCheck2.default)(this, Success);
  this.fileId = fileId;
  this.fileName = fileName;
  this.fileSize = fileSize;

  if (urlDownload) {
    this.urlDownload = urlDownload;
  }

  this.provider = providers;

  if (fileBlob) {
    this.fileBlob = fileBlob;
  }
};

exports.Success = Success;